import type { PlcManufacturerCodeLibrary } from "./types";

export const deltaCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "delta",
  manufacturer_name: "Delta Electronics",
  codes: [
    {
      id: "delta-dvp-insufficient-resource",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: null,
      code: "INSUFFICIENT DEVICE RESOURCE",
      code_type: "Programming Error",
      title_ar: "Insufficient device resource",
      description_ar: "Delta توثق رسالة insufficient device resource أثناء برمجة DVP Series ضمن مواد الدعم.",
      symptoms: ["المشروع ما يقبل compile/download بالصورة المطلوبة", "تظهر رسالة insufficient device resource"],
      causes: ["استهلاك موارد الجهاز أعلى من المتاح", "استخدام devices/resources فوق حدود الموديل"],
      checks: [
        {
          step: 1,
          action: "راجع موارد المشروع والموديل داخل WPLSoft/ISPSoft/DIADesigner حسب السلسلة.",
          expected: "استخدام الموارد ضمن حدود CPU.",
          faulty: "المشروع يتجاوز مورد أو device capacity.",
        }
      ],
      solutions: ["قلل/أعد توزيع الموارد المستخدمة.", "راجع حدود موديل DVP المحدد قبل التنزيل."],
      severity: "عالية",
      source_title: "Delta Industrial Automation e-News / DVP support",
      source_section: "Insufficient device resource message for DVP Series PLC",
      keywords: ["Delta", "DVP", "resource", "programming"],
    },
    {
      id: "delta-ah-module-status",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: null,
      code: "MODULE STATUS LED",
      code_type: "Hardware Diagnostic",
      title_ar: "AH module status diagnostic",
      description_ar: "سلسلة AH توفر Diagnosis function وModule Status LED لمتابعة حالة الموديولات.",
      symptoms: ["Module Status LED يبين Fault", "موديول ما يشتغل ضمن الـconfiguration"],
      causes: ["Module fault", "Configuration أو hot-swap state مو طبيعي", "تغذية/ربط الموديول"],
      checks: [
        {
          step: 1,
          action: "راقب Module Status LED وافتح hardware diagnostics بـISPSoft.",
          expected: "الموديول بحالة تشغيل طبيعية.",
          faulty: "الموديول يبين diagnostic/fault state.",
        }
      ],
      solutions: ["راجع Hardware Configuration والموديول المحدد.", "افحص التثبيت والتغذية بعد العزل."],
      severity: "عالية",
      source_title: "Delta AH Series PLC catalogue",
      source_section: "Diagnosis function and module status LED indicator",
      keywords: ["Delta", "AH", "diagnosis", "module status LED"],
    },
    {
      id: "delta-ah-hot-swap-diagnostic",
      manufacturer_id: "delta",
      series_id: "delta-ah",
      model: null,
      code: "HOT-SWAP DIAGNOSIS",
      code_type: "Hardware Diagnostic",
      title_ar: "AH hot-swap module diagnostic",
      description_ar: "AH Series تدعم hot-swapping مع diagnosis function على الموديولات المدعومة.",
      symptoms: ["موديول بعد hot-swap ما يرجع Online", "diagnostic يبقى فعال"],
      causes: ["موديول غير مطابق", "تركيب غير كامل", "configuration مو متزامن"],
      checks: [
        {
          step: 1,
          action: "راجع hardware configuration وحالة الموديول بعد hot-swap.",
          expected: "الموديول يرجع للحالة الطبيعية.",
          faulty: "يبقى Fault أو غير معرف.",
        }
      ],
      solutions: ["ثبت الموديول الصحيح حسب التكوين.", "راجع القيود الخاصة بالـhot-swap والموديول."],
      severity: "عالية",
      source_title: "Delta AH Series PLC catalogue",
      source_section: "Hot-swapping and diagnosis function",
      keywords: ["Delta", "AH", "hot swap", "diagnostic"],
    },
    {
      id: "delta-dvp-program-diagnostic",
      manufacturer_id: "delta",
      series_id: "delta-dvp",
      model: null,
      code: "DVP PROGRAM DIAGNOSTIC",
      code_type: "Programming/CPU Diagnostic",
      title_ar: "DVP programming diagnostic",
      description_ar: "Delta توفر أدلة Programming رسمية لسلاسل DVP ES2/EX2/EC5/SS2/SA2/SX2/SE/SE2 وMC لاستخدام التشخيص حسب السلسلة.",
      symptoms: ["ERR/diagnostic أثناء تشغيل المشروع", "برنامج أو إعداد غير مقبول"],
      causes: ["خطأ برنامج أو إعداد", "مورد غير مدعوم على الموديل"],
      checks: [
        {
          step: 1,
          action: "حدد موديل DVP وبرنامج البرمجة الصحيح ثم اقرأ التشخيص قبل تعديل المشروع.",
          expected: "ماكو تشخيص فعال.",
          faulty: "تظهر رسالة أو حالة خطأ محددة.",
        }
      ],
      solutions: ["عالج الرسالة حسب Operation/Programming Manual الخاصة بالموديل."],
      severity: "متوسطة",
      source_title: "Delta DVP Operation Manual / Download Center",
      source_section: "DVP ES2/EX2/EC5/SS2/SA2/SX2/SE/SE2 programming diagnostics",
      keywords: ["Delta", "DVP", "diagnostic"],
    },
  ],
};
